import React from 'react';
import { Button, Form } from 'react-bootstrap';

interface NumberInputProps {
    value: number;
    defaultValue?: number;
    setValue: (value: any, ...args: any[]) => void;
    step?: number;
    className?: string;
    tabIndex?: number;
    maxValue: number;
}

const NumberInput = ({
    value,
    defaultValue,
    setValue,
    className = '',
    tabIndex = -1,
    step = 1,
    maxValue
}: NumberInputProps) => {
    const handleChange = (newVal: any, event: any) => {
        event.stopPropagation();
        if (newVal < 0) return;
        if (newVal > maxValue) newVal = maxValue;
        if(isNaN(newVal)) return;
        setValue(newVal);
    };

    const keyEventHandler = (event: any) => {
        event.stopPropagation();
        switch (event.key) {
            case 'ArrowUp':
                handleChange(value + step, event);
                break;
            case 'ArrowDown':
                handleChange(Number(value - step), event);
                break;
            default:
                break;
        }
    };

    const handleFocus = (event: any) => event.target.select();

    return (
        <div className={`number-input ${className || ''}`}>
            <Button tabIndex={tabIndex} onClick={(event) => event.detail && handleChange(Number(value - step), event)}>-</Button>
            <Form.Control
                type='text'
                size='sm'
                className='NumberInput-form-control m-0'
                step={step}
                value={value}
                defaultValue={defaultValue}
                onClick={(event: any) => { event.stopPropagation(); }}
                onInput={(event) => handleChange((event.target as HTMLInputElement).value, event)}
                onKeyDown={keyEventHandler}
                onFocus={(event: any) => handleFocus(event)}
                autoComplete='off'
            />
            <Button tabIndex={tabIndex} onClick={(event) => event.detail && handleChange(value + step, event)}>+</Button>
        </div>
    );
};

export default NumberInput;